var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":5}},[(_vm.path.length > 0)?_c('GmapPolyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false},on:{"path_changed":function($event){return _vm.updateEdited($event)},"rightclick":_vm.handleClickForDelete}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }